import { RemoteConsumptionRatesService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

export const consumptionRatesService = new RemoteConsumptionRatesService(httpClient)
